import React from 'react'
import { css } from '@linaria/core'
import { colors, Paragraph } from '@fs/zion-ui'

const markerCss = css`
  position: relative;
  text-align: center;

  & > p {
    transform: translate(var(--scootch-distance));
    width: 1px;
    text-align: center;
    padding: 0 0 4px;
    font-size: 10px;
    color: ${colors.gray70};
    /* Revert word-break to normal to resolve TW-3573 */
    word-break: normal;
  }

  &::after {
    content: '';
    height: 8px;
    position: absolute;
    bottom: -4px;
    left: 0;
    margin: 0 auto;
    background: ${colors.gray10};
    width: 1px;
  }
`

export default function YearMarker({ year, yearStepSize }) {
  return (
    <div className={markerCss} style={{ '--scootch-distance': `-${year.toString().length / 2}ch` }}>
      {year % yearStepSize === 0 && <Paragraph size="xs">{year}</Paragraph>}
    </div>
  )
}
